<template>
	<div class="mb-4">
		<BaseCamera
			ref="ocrCamera"
			orientation="landscape"
			@snapshot="handleSnapshot"
			:disable-success-message="true"
			:close-on-snapshot="false"
			@scanResult="analyzeFromAppContainer"
			:scan-vehicle-registration="false"
			:take-image="true"
			:allow-upload-in-app-container="false"
			:label="$t('scan_photo')"
			:take-image-label="$t('scan_photo')"
			:remove-upload-button="isAppContainer"
			:disable-buttons="isUploading"
		>
			<template #currentSnapshot>
				<slot name="currentSnapshot">
					<BaseImage :src="image" />
				</slot>
			</template>
			<img class="absolute top-0 left-0 h-screen w-screen p-5" src="../../assets/overlay.png" alt="OCR-Overlay" />
		</BaseCamera>
	</div>
</template>

<script>
import { VehiclesApiFactory } from '@/api/generated';
import apiDefaultConfigs from '../../api/defaultConfiguration';
import BaseCamera from '@/components/forms/inputs/BaseCamera';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import BaseImage from '@/components/forms/BaseImage';
import { getStringFromDate } from '@/plugins/Utils';

export default {
	name: 'VehicleVinAnalyzer',
	components: { BaseImage, BaseCamera },
	mixins: [AppContainerMixin],
	props: {
		showSuccessMessage: { default: true },
		isSuccessAnalyzeRequire: { default: true },
		deferAnalysis: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isUploading: false,
			vehicleVinImageContent: null,
			image: null,
		};
	},
	methods: {
		analyzeFromAppContainer(json) {
			//this.isUploading = true;
			const img = json.base64Image;
			this.handleSnapshot(img);
		},
		handleSnapshot(img) {
			if (this.deferAnalysis) {
				this.image = img;
				this.$emit('snapshot', img);
				return;
			}
			this.analyzeVehicleRegistration(img);
		},
		analyzeVehicleRegistration(img) {
			this.image = img;
			if (!this.deferAnalysis) {
				this.$emit('snapshot', img);
			}
			this.isUploading = true;

			VehiclesApiFactory(apiDefaultConfigs.config(), apiDefaultConfigs.basePath, apiDefaultConfigs.axios)
				.registrationdocumentsPost({
					img: img,
					type: 'vin',
				})
				.then(res => {
					this.$emit('showEmpty');
					if (!res.data.data.VIN) {
						this.$swal({
							title: this.$t('general.attention').toString(),
							text: this.$t('incomplete_data_please_update_manually').toString(),
							cancelButtonText: this.$t('general.next').toString(),
							showCancelButton: true,
							confirmButtonText: this.$t('take_again').toString(),
							icon: 'warning',
						}).then(result => {
							this.$emit('hideEmpty');
							if (result.value) {
								this.$refs.ocrCamera.openUpload();
							} else {
								this.vehicleVinImageContent = res.data.data;
								this.vehicleVinImageContent.image = img;
								this.$emit('vehicleVinImageContent', this.vehicleVinImageContent);
								this.isUploading = false;
							}
						});
					} else {
						this.$swal(this.$t('general.success').toString(), this.$t('analysed_vin').toString(), 'success').then(_ => {
							this.vehicleVinImageContent = res.data.data;
							this.vehicleVinImageContent.image = img;
							this.$emit('hideEmpty');
							this.$emit('vehicleVinImageContent', this.vehicleVinImageContent);
							this.isUploading = false;
						});
					}
				})
				.catch(() => {
					this.$emit('showEmpty');
					this.$swal({
						title: this.$t('general.error').toString(),
						text: this.$t('analyse_error_vin').toString(),
						cancelButtonText: this.$t('general.next').toString(),
						showCancelButton: true,
						confirmButtonText: this.$t('take_again').toString(),
						icon: 'error',
					}).then(result => {
						this.$emit('hideEmpty');
						if (result.value) {
							this.$refs.ocrCamera.openUpload();
						} else {
							if (this.isSuccessAnalyzeRequire === false) {
								this.$emit('vehicleVinImageContent', { manufacturer: null, image: img });
							}
							this.isUploading = false;
						}
					});
				});
		},
	},
};
</script>

<style scoped></style>
